import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent(props) {
  var color = props.color;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.173 3.114c.202-.221.488-.347.788-.347h6.078c.3 0 .586.126.788.347l1.627 1.782c.18.197.28.454.28.72v6.55c0 .59-.478 1.067-1.067 1.067H3.333c-.589 0-1.066-.477-1.066-1.066V5.616c0-.266.1-.523.279-.72l1.627-1.782zm.788.453a.267.267 0 00-.197.086L3.444 5.1h9.113l-1.32-1.447a.267.267 0 00-.198-.086H4.961zM12.933 5.9H3.067v6.267c0 .147.119.266.266.266h9.334c.147 0 .266-.12.266-.266V5.9zm-6.28.693a.4.4 0 01-.08.56l-.373.28H9a2.067 2.067 0 110 4.133H7.373a.4.4 0 010-.8H9a1.267 1.267 0 100-2.533H6.2l.373.28a.4.4 0 11-.48.64l-1.19-.893a.533.533 0 010-.853l1.19-.894a.4.4 0 01.56.08z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }));
}
export default SvgComponent;